import React from 'react';

import { useLocalPref } from '../../hooks/useLocalPref';
import { theme } from '../../style';
import { Button } from '../common/Button';
import { Text } from '../common/Text';
import { useProgressChecklist } from '../onboarding/ProgressChecklistContext';
import { Setting } from './UI';

function formatSnoozeRemaining(dismissedUntil: number): string {
  const msLeft = dismissedUntil - Date.now();
  const totalMinutes = Math.ceil(msLeft / (60 * 1000));
  const totalHours = Math.floor(msLeft / (60 * 60 * 1000));
  const days = Math.floor(totalHours / 24);
  const hours = totalHours % 24;

  if (totalMinutes < 60) {
    return 'less than an hour';
  }
  if (days === 0) {
    return `${hours} hour${hours !== 1 ? 's' : ''}`;
  }
  if (hours === 0) {
    return `${days} day${days !== 1 ? 's' : ''}`;
  }
  return `${days} day${days !== 1 ? 's' : ''} ${hours} hour${hours !== 1 ? 's' : ''}`;
}

export function OnboardingChecklistSetting() {
  const { state, restoreChecklist, hideChecklist } = useProgressChecklist();
  const [dismissedUntil] = useLocalPref('progressChecklist.dismissedUntil');

  const isSnoozed =
    !!dismissedUntil && dismissedUntil > Date.now();

  return (
    <Setting
      primaryAction={
        state.showChecklist ? (
          <Button onClick={hideChecklist}>Hide checklist</Button>
        ) : (
          <Button type="primary" onClick={restoreChecklist}>
            Show checklist
          </Button>
        )
      }
    >
      <Text>
        <strong>Onboarding Checklist</strong> — a floating bubble that guides
        you through key features like linking accounts, categorizing
        transactions, and setting up a budget.
      </Text>
      {!state.showChecklist && (
        <Text style={{ color: theme.noticeTextLight }}>
          {isSnoozed
            ? `Snoozed for ${formatSnoozeRemaining(dismissedUntil)} from now.`
            : 'The checklist is currently hidden.'}
        </Text>
      )}
    </Setting>
  );
}
